import React from 'react';
import translate, { TranslationString } from '../functions/translate';

interface TranslatedSpanProps {
    english: TranslationString
    id?: string
    replacements?: any
    translateTo?: string
    style?: React.CSSProperties
    className?: string
}

const TranslatedSpan = (props: TranslatedSpanProps) => <span id={props.id} style={props.style}>{translate(props.english, props.replacements, props.translateTo)}</span>;

export default TranslatedSpan;